<aside [class.borderless]="borderless()">
    <app-logo size="lg" />

    <nav role="navigation" [attr.aria-label]="'header.navigation.aria-label' | translate">
        <app-menu />
    </nav>
</aside>
